export { consentsEn } from './en';
export { consentsSk } from './sk';
export { consentsCz } from './cz';

// Helper function to get consents by language
import { consentsEn } from './en';
import { consentsSk } from './sk';
import { consentsCz } from './cz';

export function getConsents(lang: string) {
  switch (lang.toLowerCase()) {
    case 'sk':
      return consentsSk;
    case 'cz':
      return consentsCz;
    case 'en':
    default:
      return consentsEn;
  }
}